import React from "react";
import { calculatorSlugs } from "../../../constants/calculatorApiTypes";
import UsageTab from "../components/UsageTab";
import { getCalculationsUsage } from "../services";

export function CalculatorApiCalculations() {
  return (
    <UsageTab
      fetchUsage={getCalculationsUsage}
      labels={calculatorSlugs}
      breakdownLabel="Calculadora"
    />
  );
}
